// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import compEntity from './entities/comp.json';
import compMenu from '../pages/comp/menu.json';
import compFullForm from '../pages/comp/forms/full.json';
import compContextForm from '../pages/comp/forms/context.json';
import compMiniForm from '../pages/comp/forms/mini.json';
import compLookupForm from '../pages/comp/forms/lookup.json';
import compTableView from '../pages/comp/views/table.json';
import compStagesView from '../pages/comp/views/stages.json';
import compCardsView from '../pages/comp/views/cards.json';
import compInlineView from '../pages/comp/views/inline.json';
import compBacklogView from '../pages/comp/views/backlog.json';
import compSplitView from '../pages/comp/views/split.json';
import compCalendarView from '../pages/comp/views/calendar.json';
import compDashboardView from '../pages/comp/views/dashboard.json';

/** Тип запису «Компетенція» зі сторінками пакета: меню, форми та подання з pages/comp/. */
export const compDefinition: IRecordTypeDefinition = {
  ...compEntity,
  views: assembleViewSet({
      table: compTableView,
      stages: compStagesView,
      cards: compCardsView,
      inline: compInlineView,
      backlog: compBacklogView,
      split: compSplitView,
      calendar: compCalendarView,
      dashboard: compDashboardView,
  }),
  form: compFullForm,
  forms: { full: compFullForm, context: compContextForm, mini: compMiniForm, lookup: compLookupForm },
  menu: compMenu,
} as IRecordTypeDefinition;
